export enum ERRORS {
  NOT_FOUND_ROUTE = "error/404",
  SERVER_ERROR_ROUTE = "error/500",
  ERROR_404 = 404,
  ERROR_409 = 409,
}

export enum ERROR_RESPONSE_CODE {
  GENERAL_UNPROCESSABLE_ENTITY = "GENERAL.UNPROCESSABLE_ENTITY",
}
